import PageLayout from "@/components/PageLayout";
import ArticleSchema from "@/components/ArticleSchema";

const BedrijfskledingWerkkleding = () => (
  <PageLayout
    title="Bedrijfskleding of werkkleding bedrukken"
    metaDescription="Bedrijfskleding en werkkleding bedrukken en borduren bij Magic Print. Werkjassen, werkbroeken, veiligheidsvestjes van Portwest, Yoko en B&C Pro."
  >
    <ArticleSchema title="Bedrijfskleding of werkkleding bedrukken" description="Bedrijfskleding en werkkleding bedrukken en borduren bij Magic Print." slug="/bedrijfskleding-of-werkkleding-bedrukken" />
    <h1 className="text-3xl md:text-5xl font-bold mb-6">
      Bedrijfskleding of werkkleding bedrukken
    </h1>

    <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
      Bedrijfskleding, ook wel werkkleding genoemd, is erg belangrijk omdat het zowel functioneel als promotioneel kan zijn mits goed gekozen en goed gepersonaliseerd.
    </p>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Veiligheidskleding</h2>
      <p className="text-muted-foreground mb-4">
        Voor sommige bedrijfstakken heeft de veiligheid prioriteit en is zichtbaarheid van groot belang. Veiligheidsjassen, broeken en veiligheidsvestjes vergroten de zichtbaarheid dankzij fluorescerende kleuren. De reflecterende strepen zorgen ervoor dat ook bij slecht zicht of bij avond/nachtwerk de werknemer goed te zien is.
      </p>
      <p className="text-muted-foreground">
        Goede en betaalbare merken hiervoor zijn Portwest en Yoko, B&C Pro – goedgekeurd en zeer betaalbaar. Voor de zware klussen leveren wij werkkleding en bedrijfskleding van Result, Portwest en Yoko. Deze merken zijn goedgekeurd en getest en hebben alle benodigde certificaten.
      </p>
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Horecakleding</h2>
      <p className="text-muted-foreground">
        Wij zijn ook gespecialiseerd in horecakleding. Onze merken Bargear, Bistro bij Jasz en Karlowsky zijn duurzaam en zeer goed betaalbaar. Ze zijn in vele modellen en kleuren verkrijgbaar en geven samen met een mooie bedrukking of borduring uw bedrijf een professionele uitstraling.
      </p>
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Bedrukken en borduren</h2>
      <p className="text-muted-foreground">
        Alle werkkleding en bedrijfskleding kunnen wij voor u bedrukken of borduren zodat uw bedrijf een professionele en betrouwbare uitstraling krijgt. Wij garanderen u de beste kwaliteit tegen de laagste prijs!
      </p>
    </section>
  </PageLayout>
);

export default BedrijfskledingWerkkleding;
